import * as Sentry from "@sentry/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LENDING_CSRF_QUERY_KEY } from "@lending/lib/api";

const noop = () => null;

async function deleteLendingSession() {
  const response = await fetch(`${import.meta.env.VITE_PUBLIC_API_URL}/v2/lending/session`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Failed to delete lending session: ${response.status}`);
  }
  return response;
}

async function deleteAccountOpeningSession() {
  const response = await fetch(`${import.meta.env.VITE_PUBLIC_API_URL}/v1/session`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Failed to delete account opening session: ${response.status}`);
  }
  return response;
}

interface Props {
  onSuccess?: () => void;
}
function useDeleteSessionQuery(props: Props = {}) {
  const { onSuccess = noop } = props;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => Promise.all([deleteLendingSession(), deleteAccountOpeningSession()]),
    onSuccess: () => {
      // The token belonged to the session just deleted; the next write fetches a fresh one.
      queryClient.removeQueries({ queryKey: LENDING_CSRF_QUERY_KEY });
      onSuccess();
    },
    onError: (error) => {
      Sentry.captureException(error);
    },
  });
}

export { useDeleteSessionQuery };
